import React from 'react';
import { motion } from 'framer-motion';
import { NewsItem } from './NewsItem';
import { newsItems } from '../data/newsData';

export default function LatestNews() {
  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {newsItems.map((item, index) => (
            <NewsItem key={item.title} item={item} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}